export default __webpack_public_path__ + "static/media/uva-logo.aace2ec0.jpg";